import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Container, TextContainer, Text, ButtonContainer } from "./styles";
import { Page } from "../page-base";

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasConsent = Cookies.get("cookie-consent");
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookie-consent", "true", { expires: 365 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Container>
      <TextContainer>
        <Text>
          Este site utiliza cookies para melhorar sua experiência. Os cookies
          são utilizados para: autenticação segura e funcionalidades essenciais
          do site. Ao continuar navegando, você concorda com o uso destes
          cookies.
        </Text>
      </TextContainer>
      <ButtonContainer>
        <Page.Button label="Aceitar" onClick={handleAccept} />
      </ButtonContainer>
    </Container>
  );
};

export default CookieConsent;
